import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import TransactionCashFlowType from './PayableReceivableCashFlowType';
import PayableReceivableCashFlowType from './PayableReceivableCashFlowType';

/**
 * Componente responsável por listar os tipos de movimentações.
 */
const PayableReceivableCashFlowTypeSelect = (props) => {
  
  const { t } = useTranslation();
  const { value, onChange, error } = props;
  const options = [
    { value: PayableReceivableCashFlowType.PAYABLE, label: t('cash_flow.payable') },
    { value: PayableReceivableCashFlowType.RECEIVABLE, label: t('cash_flow.receivable') }
];

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default PayableReceivableCashFlowTypeSelect;